import * as dg from './dx/dataGridHelper';

export const isEndState = todo => {
    return todo && ['Completed', 'Canceled'].some(s => s === todo.status)
}

export const getTodoInstanceStatusDescription = status => {
    if (status) {
        switch (status.toLowerCase()) {
            case 'inprogress':
                return 'In Progress';

            default:
                return status;
        }
    }
}

export const getStatusFilters = () => {
    return [
        {
            text: 'Pending',
            value: 'Pending'
        },
        {
            text: 'In Progress',
            value: 'InProgress'
        },
        {
            text: 'Reopened',
            value: 'Reopened'
        },
        {
            text: 'Completed',
            value: 'Completed'
        }
    ];
}

export const getLastUpdatedDateFilters = () => {
    return dg.getDefaultLastDateFilters('LastUpdatedDateUtc');
}

export const getQuickFilterDescription = (type) => {
    if (type) {
        switch (type) {
            case 'YourOutstanding':
                return 'Outstanding tasks (All)';

            case 'YourOutstandingUser':
                return 'Outstanding tasks (User)';

            case 'YourOutstandingSystem':
                return 'Outstanding tasks (System)';

            case 'YourRecentlyCompleted':
                return 'Recently completed tasks';

            case 'YourCompleted':
                return 'All completed tasks';

            case 'ScheduledCreatedByYou':
                return 'Future tasks';

            case 'OutstandingCreatedByYou':
                return 'Outstanding tasks';

            case 'RecentlyCompletedCreatedByYou':
                return 'Recently completed tasks';

            case 'AllCompletedCreatedByYou':
                return 'All completed tasks';

            case 'AllOutstanding':
                return 'All outstanding tasks';

            case 'AllOutstandingUser':
                return 'All outstanding tasks (User)';

            case 'AllOutstandingSystem':
                return 'All outstanding tasks (System)';

            case 'RecentlyUpdated':
                return 'Recently updated tasks';

            case 'RecentlyCompleted':
                return 'Recently completed tasks';

            case 'AllCompleted':
                return 'All completed tasks';

            default:
                return null;
        }
    }
    return null;
}

export const getQuickFilterDefinition = (type, auth) => {
    if (type) {
        const lastUpdatedDateFilters = getLastUpdatedDateFilters();

        const outstandingStatusFilter =
        {
            column: 'Status',
            headerFilters: ['Pending', 'InProgress', 'Reopened'],
        };
        const completedStatusFilter =
        {
            column: 'Status',
            headerFilters: ['Completed'],
        };

        switch (type) {
            case 'YourOutstandingUser':
                return [{
                    column: 'CreatedBy',
                    filter: {
                        operator: '!=',
                        value: 'System'
                    },
                }, {
                    column: 'IsScheduled',
                    filter: {
                        operator: '=',
                        value: false
                    },
                }, {
                    column: 'RelatedTo',
                    headerFilters: auth && auth.currentUser ? [auth.currentUser.id] : [],
                }, {
                    column: 'BodyHtml',
                    sort: 'asc',
                }, outstandingStatusFilter];

            case 'YourOutstandingSystem':
                return [{
                    column: 'CreatedBy',
                    filter: {
                        operator: '=',
                        value: 'System'
                    },
                }, {
                    column: 'IsScheduled',
                    filter: {
                        operator: '=',
                        value: false
                    },
                }, {
                    column: 'RelatedTo',
                    headerFilters: auth && auth.currentUser ? [auth.currentUser.id] : [],
                }, {
                    column: 'BodyHtml',
                    sort: 'asc',
                }, outstandingStatusFilter];

            case 'YourOutstanding':
                return [{
                    column: 'RelatedTo',
                    headerFilters: auth && auth.currentUser ? [auth.currentUser.id] : [],
                }, {
                    column: 'IsScheduled',
                    filter: {
                        operator: '=',
                        value: false,
                    },
                }, {
                    column: 'BodyHtml',
                    sort: 'asc',
                }, outstandingStatusFilter];

            case 'YourRecentlyCompleted':
                return [{
                    column: 'CompletedBy',
                    headerFilters: auth && auth.currentUser ? [auth.currentUser.id] : [],
                }, {
                    column: 'IsScheduled',
                    filter: {
                        operator: '=',
                        value: false,
                    },
                }, {
                    column: 'LastUpdatedDateUtc',
                    headerFilters: [lastUpdatedDateFilters.filter(u => u.text === 'Last 30 days')[0].value],
                    sortOrder: 'asc'
                }, completedStatusFilter];

            case 'YourCompleted':
                return [{
                    column: 'CompletedBy',
                    headerFilters: auth && auth.currentUser ? [auth.currentUser.id] : [],
                }, {
                    column: 'IsScheduled',
                    filter: {
                        operator: '=',
                        value: false,
                    },
                }, {
                    column: 'LastUpdatedDateUtc',
                    sortOrder: 'asc'
                }, completedStatusFilter];

            case 'ScheduledCreatedByYou':
                return [{
                    column: 'CreatedById',
                    filter: {
                        operator: '=',
                        value: auth && auth.currentUser ? auth.currentUser.id : null,
                    },
                }, {
                    column: 'IsScheduled',
                    filter: {
                        operator: '=',
                        value: true,
                    },
                }, {
                    column: 'BodyHtml',
                    sort: 'asc',
                }, outstandingStatusFilter];

            case 'OutstandingCreatedByYou':
                return [{
                    column: 'CreatedById',
                    filter: {
                        operator: '=',
                        value: auth && auth.currentUser ? auth.currentUser.id : null,
                    },
                }, {
                    column: 'IsScheduled',
                    filter: {
                        operator: '=',
                        value: false,
                    },
                }, {
                    column: 'BodyHtml',
                    sort: 'asc',
                }, outstandingStatusFilter];

            case 'RecentlyCompletedCreatedByYou':
                return [{
                    column: 'CreatedById',
                    filter: {
                        operator: '=',
                        value: auth && auth.currentUser ? auth.currentUser.id : null,
                    },
                }, {
                    column: 'IsScheduled',
                    filter: {
                        operator: '=',
                        value: false,
                    },
                }, {
                    column: 'LastUpdatedDateUtc',
                    headerFilters: [lastUpdatedDateFilters.filter(u => u.text === 'Last 30 days')[0].value],
                    sortOrder: 'asc'
                }, completedStatusFilter];

            case 'AllCompletedCreatedByYou':
                return [{
                    column: 'CreatedById',
                    filter: {
                        operator: '=',
                        value: auth && auth.currentUser ? auth.currentUser.id : null,
                    },
                }, {
                    column: 'IsScheduled',
                    filter: {
                        operator: '=',
                        value: false,
                    },
                }, completedStatusFilter];

            case 'AllOutstanding':
                return [{
                    column: 'BodyHtml',
                    sort: 'asc',
                }, {
                    column: 'IsScheduled',
                    filter: {
                        operator: '=',
                        value: false,
                    },
                }, outstandingStatusFilter];

            case 'AllOutstandingUser':
                return [{
                    column: 'CreatedBy',
                    filter: {
                        operator: '!=',
                        value: 'System'
                    },
                }, {
                    column: 'IsScheduled',
                    filter: {
                        operator: '=',
                        value: false,
                    },
                }, {
                    column: 'BodyHtml',
                    sort: 'asc',
                }, outstandingStatusFilter];

            case 'AllOutstandingSystem':
                return [{
                    column: 'CreatedBy',
                    filter: {
                        operator: '=',
                        value: 'System'
                    },
                }, {
                    column: 'IsScheduled',
                    filter: {
                        operator: '=',
                        value: false,
                    },
                }, {
                    column: 'BodyHtml',
                    sort: 'asc',
                }, outstandingStatusFilter];

            case 'RecentlyUpdated':
                return [{
                    column: 'LastUpdatedDateUtc',
                    headerFilters: [lastUpdatedDateFilters.filter(u => u.text === 'Last 30 days')[0].value],
                    sortOrder: 'asc'
                }, {
                    column: 'IsScheduled',
                    filter: {
                        operator: '=',
                        value: false,
                    },
                }, outstandingStatusFilter];

            case 'RecentlyCompleted':
                return [{
                    column: 'LastUpdatedDateUtc',
                    headerFilters: [lastUpdatedDateFilters.filter(u => u.text === 'Last 30 days')[0].value],
                    sortOrder: 'asc'
                }, {
                    column: 'IsScheduled',
                    filter: {
                        operator: '=',
                        value: false,
                    },
                }, completedStatusFilter];

            case 'AllCompleted':
                return [{
                    column: 'LastUpdatedDateUtc',
                    sortOrder: 'asc'
                }, {
                    column: 'IsScheduled',
                    filter: {
                        operator: '=',
                        value: false,
                    },
                }, completedStatusFilter];

            default:
                return;
        }
    }
}
